
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsUnitDialog extends Serenity.EntityDialog<CsUnitRow, any> {
        protected getFormKey() { return CsUnitForm.formKey; }
        protected getIdProperty() { return CsUnitRow.idProperty; }
        protected getLocalTextPrefix() { return CsUnitRow.localTextPrefix; }
        protected getNameProperty() { return CsUnitRow.nameProperty; }
        protected getService() { return CsUnitService.baseUrl; }
        protected getDeletePermission() { return CsUnitRow.deletePermission; }
        protected getInsertPermission() { return CsUnitRow.insertPermission; }
        protected getUpdatePermission() { return CsUnitRow.updatePermission; }

        protected form = new CsUnitForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Unitid = Q.tryFirst(CsSkuRow.getLookup().items, x => x.StkUnit == this.entity.UnitId);
            if(Unitid != null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.SellUnit == this.entity.UnitId);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }
       
    }
}